import { log } from './log';

export const sendWsMessage = (ws, message) => {
  if (message && message.type !== 'mbackend' && message.type !== 'transcript-edit') {
    log('websocketMessage', 'info', { message, direction: 'f2b' });
  }
  if (ws) {
    ws.send(JSON.stringify(message));
  }
};

export const sendConnectionRequestMessage = (ws, fromSource, to, options) => {
  const id = Date.now().toString();
  const message = {
    type: 'connection-request',
    fromSource,
    id,
    to,
    ...options,
  };
  sendWsMessage(ws, message);
  return id;
};

export const sendResetRoomIdMessage = (ws, roomId) =>
  sendWsMessage(ws, {
    type: 'connection-params-update',
    roomId,
  });

export const sendSaveTranscriptUpdateMessage = (ws, saveTranscript) => {
  return sendWsMessage(ws, {
    type: 'connection-params-update',
    saveTranscript,
  });
};

export const sendConversationModeUpdateMessage = (ws, conversationMode) => {
  return sendWsMessage(ws, {
    type: 'connection-params-update',
    conversationMode,
  });
};

export const sendRoomStateUpdateMessage = (ws, state) => {
  return sendWsMessage(ws, {
    type: 'connection-params-update',
    state,
  });
};

export const sendUsePaidAsrUpdateMessage = (ws, usePaidASR) =>
  sendWsMessage(ws, {
    type: 'connection-params-update',
    usePaidASR,
  });

export const sendAccountUpdateMessage = ws =>
  sendWsMessage(ws, {
    type: 'account-update',
  });

export const getDefaultRoomId = id => `${id.slice(0, 8)}_00000000-0000-0000-0000-000000000000`;

export const isDefaultRoomId = roomId => roomId.includes('_00000000-0000-0000-0000-000000000000');

export const isConversationEnded = (status, user) => {
  const host = (status.id || '').split('_')[0];
  // eslint-disable-next-line
  for (let participant of status.participants || []) {
    if (participant.channel !== 'web') {
      return false;
    }
    if (status.id && host === participant.avaId) {
      return false;
    }
  }
  if (status.id && host === user.avaId) {
    return false;
  }
  return true;
};

export const sendUserQueryMessage = (ws, avaNameStartsWith) =>
  sendWsMessage(ws, {
    type: 'user-query',
    avaNameStartsWith,
  });

export const sendEmailQueryMessage = (ws, emailEqualTo) =>
  sendWsMessage(ws, {
    type: 'user-query',
    emailEqualTo,
  });

export const updateDownAudio = (ws, speaker) => {
  if (speaker.audioLink) {
    sendWsMessage(ws, {
      type: 'connection-params-update',
      downAudio: {
        forceSR: false,
        audioLink: true,
      },
    });
  } else {
    sendWsMessage(ws, {
      type: 'connection-params-update',
      downAudio: {
        speakerId: speaker.avaId,
        trackId: speaker.trackId,
        forceSR: speaker.forceSR,
      },
    });
  }
};

export const sendMbackendMessage = (ws, data) => {
  return sendWsMessage(ws, {
    type: 'mbackend',
    content: JSON.stringify(data),
  });
};

export const sendBoostMessage = (ws, data) => {
  sendWsMessage(ws, {
    type: 'boost',
    ...data,
  });
};

export const sendAudioParams = (ws, audioParams) =>
  sendWsMessage(ws, {
    type: 'connection-params-update',
    audio: audioParams,
  });

export const sendUpdateTranscriptOwnerMessage = (ws, message) =>
  sendWsMessage(ws, {
    type: 'update-transcript-owner',
    ...message,
  });

export const sendUpdateTitleMessage = (ws, message) =>
  sendWsMessage(ws, {
    type: 'update-title',
    ...message,
  });

export const sendForceMute = (ws, avaId) =>
  sendWsMessage(ws, {
    type: 'force-mute',
    avaId,
  });

export const sendTypeOnly = (ws, type) =>
  sendWsMessage(ws, {
    type,
  });

export const sendPing = ws =>
  sendWsMessage(ws, {
    type: 'ping',
    id: Date.now().toString(),
  });

export const respondPingMessage = (ws, pongMessage) =>
  sendWsMessage(ws, {
    type: 'PONG',
    serverTimeMs: pongMessage.serverTimeMs,
    clientTimeMs: Date.now(),
  });

export const sendAccessBoostWords = (ws, action, words = undefined) => {
  sendWsMessage(ws, {
    type: 'access-boost-words',
    action,
    words,
  });
};
